import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
    {
        n: "01",
        title: "Konsultasi & Survei Lokasi",
        desc: "Kita dengarkan kebutuhan Anda, lalu ukur langsung di lokasi agar setiap dimensi presisi.",
    },
    {
        n: "02",
        title: "Desain, Ukuran & RAB",
        desc: "Anda menerima gambar kerja, pilihan material, dan rincian anggaran yang jelas sebelum dimulai.",
    },
    {
        n: "03",
        title: "Fabrikasi & Pemasangan",
        desc: "Fabrikasi profil aluminium dan kaca tempered, lalu dipasang oleh tim sendiri — rapi dan aman.",
    },
    {
        n: "04",
        title: "Serah Terima & Garansi",
        desc: "Pemeriksaan akhir bersama Anda, pembersihan area kerja, dan garansi pemasangan.",
    },
];

export default function Process() {
    return (
        <section id="proses" className="py-24 lg:py-32">
            <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
                <div className="lg:sticky lg:top-28 lg:self-start">
                    <Reveal>
                        <Eyebrow>Proses Kami</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2 className="mt-6 font-serif text-4xl font-medium leading-tight text-white lg:text-5xl">
                            Empat langkah, tanpa drama.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
                            Alur kerja yang jelas dari awal hingga serah terima
                            — Anda selalu tahu posisi proyek Anda.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="img-frame mt-10 aspect-[4/3] w-full">
                            <img
                                src="https://images.unsplash.com/photo-1603901622056-0a5bee231395?q=80&w=1200&auto=format&fit=crop"
                                alt="Gambar kerja dan perencanaan"
                                loading="lazy"
                                className="h-full w-full object-cover opacity-80"
                            />
                        </div>
                    </Reveal>
                </div>

                <div>
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.06}>
                            <div
                                data-testid="process-step"
                                className="group border-b border-white/10 py-9 transition-[padding] duration-500 first:border-t hover:pl-3 lg:py-11"
                            >
                                <div className="flex items-baseline gap-6 lg:gap-10">
                                    <span className="font-mono text-sm text-gold">
                                        {s.n}
                                    </span>
                                    <div>
                                        <h3 className="font-serif text-2xl text-white lg:text-3xl">
                                            {s.title}
                                        </h3>
                                        <p className="mt-3 max-w-lg text-sm leading-relaxed text-zinc-400">
                                            {s.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
